import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../components/PageContainer';
import AdminUserTable from '../components/AdminUserTable';

const panelClasses =
  'flex flex-col min-h-0 overflow-hidden rounded-3xl border border-white/10 bg-white/70 p-5 text-slate-900 shadow-xl shadow-slate-900/10 backdrop-blur-xl dark:border-white/5 dark:bg-slate-900/60 dark:text-white dark:shadow-black/20';

export default function Admin() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState('none');

  const fetchData = async () => {
    const params = new URLSearchParams();
    params.set('sort_by', sortBy || 'created_at');
    params.set('sort_dir', sortDir);
    try {
      const res = await fetch(`/api/admin_users.php?${params.toString()}`, {
        credentials: 'include'
      });
      if (res.status === 403) {
        navigate('/login');
        return;
      }
      const json = await res.json();
      setData(json);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortBy, sortDir]);

  const handleSort = (column) => {
    if (sortBy === column && sortDir === 'desc') {
      setSortDir('asc');
    } else if (sortBy === column && sortDir === 'asc') {
      setSortBy(null);
      setSortDir('none');
    } else {
      setSortBy(column);
      setSortDir('desc');
    }
  };

  return (
    <PageContainer className="relative overflow-hidden bg-slate-950 text-slate-100">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(56,189,248,0.18),transparent_55%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.16),transparent_55%)]" />
      <div className="relative z-10 flex flex-1 flex-col gap-6">
        <header className="flex flex-col gap-4">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-white/30 bg-white/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-200">
            Access Control
          </span>
          <div className="space-y-2">
            <h1 className="text-3xl font-semibold leading-tight text-white md:text-4xl">Admin</h1>
            <p className="max-w-2xl text-sm text-slate-300">
              Manage privileged users, review recent access events, and ensure the command center stays secure.
            </p>
          </div>
        </header>

        <section className={panelClasses}>
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-white">User Information</h2>
            <span className="text-xs font-medium text-slate-300">Live directory</span>
          </div>
          <div className="mt-4 flex-1 min-h-0 overflow-hidden rounded-2xl border border-white/10 bg-slate-950/40">
            <AdminUserTable data={data} sortBy={sortBy} sortDir={sortDir} onSort={handleSort} />
          </div>
        </section>
      </div>
    </PageContainer>
  );
}
